<template>
    <div ref="json-editor"/>
</template>

<script>

import { JSONEditor } from '@json-editor/json-editor'
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faPlus, faTrash, faList, faMinus, faCaretDown, faCaretRight, faTimes, faPen, faBan, faSave, faArrowUp, faArrowDown, faCopy, faTimesCircle, faClock, faCalendar } from '@fortawesome/free-solid-svg-icons'
library.add(faPlus, faTrash, faList, faMinus, faCaretDown, faCaretRight, faTimes, faPen, faBan, faSave, faArrowUp, faArrowDown, faCopy, faTimesCircle, faClock, faCalendar)

export default {
  name: 'JsonEditor',
  props: {
    ajax: {
      type: Boolean,
      default: false
    },
    ajaxBase: {
      type: String,
      default: ''
    },
    ajaxCredentials: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    disable_array_add: {
      type: Boolean,
      default: false
    },
    disable_array_delete: {
      type: Boolean,
      default: false
    },
    disable_array_delete_all_rows: {
      type: Boolean,
      default: false
    },
    disable_array_delete_last_row: {
      type: Boolean,
      default: false
    },
    disable_array_reorder: {
      type: Boolean,
      default: false
    },
    enable_array_copy: {
      type: Boolean,
      default: false
    },
    disable_collapse: {
      type: Boolean,
      default: false
    },
    disable_edit_json: {
      type: Boolean,
      default: false
    },
    disable_properties: {
      type: Boolean,
      default: false
    },
    array_controls_top: {
      type: Boolean,
      default: false
    },
    form_name_root: {
      type: String,
      default: 'root'
    },
    iconlib: {
      type: String,
      default: 'fontawesome5'
    },
    remove_button_labels: {
      type: Boolean,
      default: false
    },
    no_additional_properties: {
      type: Boolean,
      default: false
    },
    refs: {
      type: Object,
      default: () => { return {} }
    },
    required_by_default: {
      type: Boolean,
      default: false
    },
    keep_oneof_values: {
      type: Boolean,
      default: true
    },
    schema: {
      type: Object,
      default: () => { return {} }
    },
    show_errors: {
      type: String,
      default: 'interaction'
    },
    startval: {},
    template: {
      type: String,
      default: 'default'
    },
    theme: {
      type: String,
      default: 'bootstrap4'
    },
    display_required_only: {
      type: Boolean,
      default: false
    },
    show_opt_in: {
      type: Boolean,
      default: false
    },
    prompt_before_delete: {
      type: Boolean,
      default: true
    },
    object_layout: {
      type: String,
      default: 'normal'
    },
    enum_source_value_auto_select: {
      type: Boolean,
      default: true
    },
    max_depth: {
      type: Number,
      default: 0
    },
    use_default_values: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      jsonEditor: null
    }
  },
  mounted () {
    this.jsonEditor = new JSONEditor(this.$refs['json-editor'], {
      ajax: this.ajax,
      ajaxBase: this.ajaxBase,
      ajaxCredentials: this.ajaxCredentials,
      compact: this.compact,
      disable_array_add: this.disable_array_add,
      disable_array_delete: this.disable_array_delete,
      disable_array_delete_all_rows: this.disable_array_delete_all_rows,
      disable_array_delete_last_row: this.disable_array_delete_last_row,
      disable_array_reorder: this.disable_array_reorder,
      enable_array_copy: this.enable_array_copy,
      disable_collapse: this.disable_collapse,
      disable_edit_json: this.disable_edit_json,
      disable_properties: this.disable_properties,
      array_controls_top: this.array_controls_top,
      form_name_root: this.form_name_root,
      iconlib: this.iconlib,
      remove_button_labels: this.remove_button_labels,
      no_additional_properties: this.no_additional_properties,
      refs: this.refs,
      required_by_default: this.required_by_default,
      keep_oneof_values: this.keep_oneof_values,
      schema: this.schema,
      show_errors: this.show_errors,
      startval: this.startval,
      template: this.template,
      theme: this.theme,
      display_required_only: this.display_required_only,
      show_opt_in: this.show_opt_in,
      prompt_before_delete: this.prompt_before_delete,
      object_layout: this.object_layout,
      enum_source_value_auto_select: this.enum_source_value_auto_select,
      max_depth: this.max_depth,
      use_default_values: this.use_default_values
    })

    // Cause fontawesome js to evaluate newly created icons
    dom.watch()
  },
  computed: {
    json: function () {
      return this.jsonEditor ? this.jsonEditor.getValue() : {}
    }
  }
}
</script>
